import React, { PureComponent } from 'react';
import { Nav, NavItem } from 'reactstrap';
import { number, array, string } from 'prop-types';
import { Button } from 'reactstrap';
import Card from './Card';
import { FMessage } from '../../hoc/IntlComponents';

class CardCollapsible extends PureComponent {
  static propTypes = {
    items: array.isRequired,
    label: string.isRequired,
    visibleItems: number,
    title: string,
    alwaysVisibleItem: React.Element
  };

  static defaultProps = {
    items: [],
    label: '',
    visibleItems: 2,
  };

  state = {
    open: false,
  };

  toggle = () => {
    this.setState(prevState => ({
      open: !prevState.open,
    }));
  };

  renderItems = filter => {
    const { items } = this.props;

    return items
      .filter(filter)
      .map((item, index) => <li key={`CollapsibleListItem_${index}`}>{item}</li>);
  };

  render() {
    const { title, label, items, visibleItems, controls, alwaysVisibleItem, ...attributes } = this.props;
    const { open } = this.state;
    const btnLabel = !open ? `${label} (${items.length})` : <FMessage id="main.hide" />;

    return (
      <Card {...attributes}>
        {title && (
          <Card.Header className={(controls && controls.length) ? 'card-with-controls-header-container card-collapsible--with-controls' : ''}>
            <div className={(controls && controls.length) ? 'card-collapsible-controls-title' : ''}>{title}</div>
            {(controls && controls.length) > 0 && (
              <div className="card-with-controls-controls nav-pills themed-card-controls card-collapsible-controls">
                {controls.map((control, index) => (
                  <div className="card-collapsible-controls nav-item" key={index}>
                    {control}
                  </div>
                ))}
              </div>
            )}
          </Card.Header>
        )}

        <Card.Body>
          <ul className="collapsible-list">
            {this.renderItems((item, index) => index < visibleItems)}
            {open && this.renderItems((item, index) => index >= visibleItems)}
            {alwaysVisibleItem && <li key={`CollapsibleListItem_alwaysVisibleItem`}>{alwaysVisibleItem}</li>}
          </ul>
        </Card.Body>

        {visibleItems < items.length && (
          <Card.Footer className="text-center">
            <Button className="no-focus" size="sm" color="primary" onClick={this.toggle} outline>
              {btnLabel}
            </Button>
          </Card.Footer>
        )}
      </Card>
    );
  }
}

export default CardCollapsible;
